/* tslint:disable */
/* eslint-disable */
/**
 * Resell Grid Engine Rest API
 * Resell Grid Engine Rest API
 *
 * The version of the OpenAPI document: 22.4.0
 * Contact: mariogg@servicioexterno.inditex.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AgeContentFilter
 */
export interface AgeContentFilter {
    /**
     * Criterion type discriminator
     * @type {string}
     * @memberof AgeContentFilter
     */
    'type': string;
    /**
     * Maximum acceptable age in days
     * @type {number}
     * @memberof AgeContentFilter
     */
    'maxAgeInDays'?: number;
}
/**
 * 
 * @export
 * @interface AgeContentFilters
 */
export interface AgeContentFilters {
    /**
     * Criterion type discriminator
     * @type {string}
     * @memberof AgeContentFilters
     */
    'type': string;
    /**
     * Maximum acceptable age in days
     * @type {number}
     * @memberof AgeContentFilters
     */
    'maxAgeInDays'?: number;
}
/**
 * Age-based filter criterion
 * @export
 * @interface AgeGridFilterCriterion
 */
export interface AgeGridFilterCriterion extends GridFilterCriterion {
    /**
     * Maximum acceptable age in days
     * @type {number}
     * @memberof AgeGridFilterCriterion
     */
    'maxAgeInDays'?: number;
}


/**
 * 
 * @export
 * @interface AgeGridFilterCriterionAllOf
 */
export interface AgeGridFilterCriterionAllOf {
    /**
     * Maximum acceptable age in days
     * @type {number}
     * @memberof AgeGridFilterCriterionAllOf
     */
    'maxAgeInDays'?: number;
}
/**
 * 
 * @export
 * @interface CategoryContentFilter
 */
export interface CategoryContentFilter {
    /**
     * Criterion type discriminator
     * @type {string}
     * @memberof CategoryContentFilter
     */
    'type': string;
    /**
     * list of search values
     * @type {Array<number>}
     * @memberof CategoryContentFilter
     */
    'values'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CategoryContentFilters
 */
export interface CategoryContentFilters {
    /**
     * Criterion type discriminator
     * @type {string}
     * @memberof CategoryContentFilters
     */
    'type': string;
    /**
     * list of search values
     * @type {Array<number>}
     * @memberof CategoryContentFilters
     */
    'values'?: Array<number>;
}
/**
 * Category-based filter criterion
 * @export
 * @interface CategoryGridFilterCriterion
 */
export interface CategoryGridFilterCriterion extends GridFilterCriterion {
    /**
     * Ids of the entities accepted by this filter
     * @type {Array<number>}
     * @memberof CategoryGridFilterCriterion
     */
    'values'?: Array<number>;
}


/**
 * 
 * @export
 * @interface CategoryGridFilterCriterionAllOf
 */
export interface CategoryGridFilterCriterionAllOf {
    /**
     * Ids of the entities accepted by this filter
     * @type {Array<number>}
     * @memberof CategoryGridFilterCriterionAllOf
     */
    'values'?: Array<number>;
}
/**
 * @type Content
 * @export
 */
export type Content = { type: 'age' } & AgeContentFilter | { type: 'category' } & CategoryContentFilter | { type: 'option' } & OptionContentFilter | { type: 'search' } & SearchContentFilter;

/**
 * @type Contents
 * @export
 */
export type Contents = { type: 'age' } & AgeContentFilters | { type: 'category' } & CategoryContentFilters | { type: 'option' } & OptionContentFilters | { type: 'search' } & SearchContentFilters;

/**
 * 
 * @export
 * @interface Criteria
 */
export interface Criteria {
    /**
     * List of all filter definition
     * @type {Array<Content>}
     * @memberof Criteria
     */
    'criteria'?: Array<Content>;
}
/**
 * 
 * @export
 * @interface Grid
 */
export interface Grid {
    /**
     * Grid Id
     * @type {string}
     * @memberof Grid
     */
    'id'?: string;
    /**
     * The universe where it belongs
     * @type {number}
     * @memberof Grid
     */
    'universeId'?: number;
    /**
     * Is Grid the default in the universe
     * @type {boolean}
     * @memberof Grid
     */
    'defaultInUniverse'?: boolean;
    /**
     * 
     * @type {GridFilterDefinition}
     * @memberof Grid
     */
    'filterDefinition'?: GridFilterDefinition;
    /**
     * Grid description in all supported languages.
     * @type {Array<GridDescription>}
     * @memberof Grid
     */
    'descriptions': Array<GridDescription>;
    /**
     * Grid visibility on main menu
     * @type {boolean}
     * @memberof Grid
     */
    'visible'?: boolean;
    /**
     * Grid recategorization excluded
     * @type {boolean}
     * @memberof Grid
     */
    'recategorizationExcluded'?: boolean;
    /**
     * List of grid parents identifiers
     * @type {Array<Grid>}
     * @memberof Grid
     */
    'subgrids'?: Array<Grid>;
    /**
     * List of grid parents identifiers
     * @type {Array<GridSummary>}
     * @memberof Grid
     */
    'parentGrids'?: Array<GridSummary>;
    /**
     * The identifier of the external grid in Shopizer
     * @type {number}
     * @memberof Grid
     */
    'externalGridId'?: number;
    /**
     * The grid filter
     * @type {string}
     * @memberof Grid
     */
    'gridFilterId'?: string;
    /**
     * Grid published flag
     * @type {boolean}
     * @memberof Grid
     */
    'isPublished'?: boolean;
    /**
     * URL of the mobile resource
     * @type {string}
     * @memberof Grid
     */
    'mobileResourceUrl'?: string;
    /**
     * URL of the desktop resource
     * @type {string}
     * @memberof Grid
     */
    'desktopResourceUrl'?: string;
    /**
     * The version of the grid
     * @type {number}
     * @memberof Grid
     */
    'version'?: number;
    /**
     * The status of the grid
     * @type {string}
     * @memberof Grid
     */
    'status'?: string;
    /**
     * The error code of the grid
     * @type {string}
     * @memberof Grid
     */
    'errorCode'?: string;
    /**
     * The error message of the grid
     * @type {string}
     * @memberof Grid
     */
    'errorMessage'?: string;
    /**
     * Flag to indicate if the grid is auto updatable
     * @type {boolean}
     * @memberof Grid
     */
    'isAutoUpdatable'?: boolean;
}
/**
 * 
 * @export
 * @interface GridData
 */
export interface GridData {
    /**
     * 
     * @type {string}
     * @memberof GridData
     */
    '@type'?: string;
    /**
     * List of grids
     * @type {Array<Grid>}
     * @memberof GridData
     */
    'data'?: Array<Grid>;
}
/**
 * Grid description in all supported languages.
 * @export
 * @interface GridDescription
 */
export interface GridDescription {
    /**
     * ISO 639-1 language code
     * @type {string}
     * @memberof GridDescription
     */
    'languageCode': string;
    /**
     * Entity name
     * @type {string}
     * @memberof GridDescription
     */
    'name'?: string;
    /**
     * Entity title
     * @type {string}
     * @memberof GridDescription
     */
    'title'?: string;
    /**
     * Entity description
     * @type {string}
     * @memberof GridDescription
     */
    'description'?: string;
}
/**
 * Base class for filter criteria
 * @export
 * @interface GridFilterCriterion
 */
export interface GridFilterCriterion {
    /**
     * Criterion type discriminator
     * @type {string}
     * @memberof GridFilterCriterion
     */
    'type': GridFilterCriterionTypeEnum;
}

export const GridFilterCriterionTypeEnum = {
    Category: 'CATEGORY',
    Option: 'OPTION',
    Age: 'AGE',
    Search: 'SEARCH'
} as const;

export type GridFilterCriterionTypeEnum = typeof GridFilterCriterionTypeEnum[keyof typeof GridFilterCriterionTypeEnum];

/**
 * Grid filter definition. This field is immutable once the grid is created.
 * @export
 * @interface GridFilterDefinition
 */
export interface GridFilterDefinition {
    /**
     * List of criteria applied for this filter
     * @type {Array<GridFilterCriterion>}
     * @memberof GridFilterDefinition
     */
    'criteria'?: Array<GridFilterCriterion>;
}
/**
 * 
 * @export
 * @interface GridIdData
 */
export interface GridIdData {
    /**
     * 
     * @type {string}
     * @memberof GridIdData
     */
    '@type'?: string;
    /**
     * List of grids IDs
     * @type {Array<string>}
     * @memberof GridIdData
     */
    'data'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GridOutdated
 */
export interface GridOutdated {
    /**
     * ID of the grid
     * @type {string}
     * @memberof GridOutdated
     */
    'gridId'?: string;
    /**
     * Indicates if the grid requires an update
     * @type {boolean}
     * @memberof GridOutdated
     */
    'requiresUpdate'?: boolean;
}
/**
 * 
 * @export
 * @interface GridPublic
 */
export interface GridPublic {
    /**
     * Grid Id
     * @type {string}
     * @memberof GridPublic
     */
    'id'?: string;
    /**
     * name of the grid
     * @type {string}
     * @memberof GridPublic
     */
    'name'?: string;
    /**
     * title of the grid
     * @type {string}
     * @memberof GridPublic
     */
    'title'?: string;
    /**
     * description of the grid
     * @type {string}
     * @memberof GridPublic
     */
    'description'?: string;
    /**
     * SEO name
     * @type {string}
     * @memberof GridPublic
     */
    'seoName'?: string;
    /**
     * SEO title
     * @type {string}
     * @memberof GridPublic
     */
    'seoTitle'?: string;
    /**
     * SEO description
     * @type {string}
     * @memberof GridPublic
     */
    'seoDescription'?: string;
    /**
     * rank of the grid
     * @type {string}
     * @memberof GridPublic
     */
    'rank'?: string;
    /**
     * default in universe grid flag
     * @type {boolean}
     * @memberof GridPublic
     */
    'defaultInUniverse'?: boolean;
    /**
     * subgrids of the grid
     * @type {Array<GridPublicSummary>}
     * @memberof GridPublic
     */
    'subGrids'?: Array<GridPublicSummary>;
    /**
     * parent grids of the grid
     * @type {Array<GridPublicSummary>}
     * @memberof GridPublic
     */
    'parentGrids'?: Array<GridPublicSummary>;
    /**
     * The identifier of the external grid in Shopizer
     * @type {number}
     * @memberof GridPublic
     */
    'externalGridId'?: number;
    /**
     * The grid filter
     * @type {string}
     * @memberof GridPublic
     */
    'gridFilterId'?: string;
    /**
     * Grid published flag
     * @type {boolean}
     * @memberof GridPublic
     */
    'isPublished'?: boolean;
    /**
     * Grid visibility
     * @type {boolean}
     * @memberof GridPublic
     */
    'visible'?: boolean;
}
/**
 * Grid summary with basic properties.
 * @export
 * @interface GridPublicSummary
 */
export interface GridPublicSummary {
    /**
     * Grid Id
     * @type {string}
     * @memberof GridPublicSummary
     */
    'id'?: string;
    /**
     * name of the grid
     * @type {string}
     * @memberof GridPublicSummary
     */
    'name'?: string;
    /**
     * title of the grid
     * @type {string}
     * @memberof GridPublicSummary
     */
    'title'?: string;
    /**
     * description of the grid
     * @type {string}
     * @memberof GridPublicSummary
     */
    'description'?: string;
    /**
     * Grid position
     * @type {number}
     * @memberof GridPublicSummary
     */
    'position'?: number;
    /**
     * Grid visibility
     * @type {boolean}
     * @memberof GridPublicSummary
     */
    'visible'?: boolean;
    /**
     * Grid published flag
     * @type {boolean}
     * @memberof GridPublicSummary
     */
    'isPublished'?: boolean;
    /**
     * The identifier of the external grid in Shopizer
     * @type {number}
     * @memberof GridPublicSummary
     */
    'externalGridId'?: number;
    /**
     * The grid filter
     * @type {string}
     * @memberof GridPublicSummary
     */
    'gridFilterId'?: string;
}
/**
 * 
 * @export
 * @interface GridStatus
 */
export interface GridStatus {
    /**
     * Status of the grid
     * @type {string}
     * @memberof GridStatus
     */
    'status'?: string;
    /**
     * Error code if any
     * @type {string}
     * @memberof GridStatus
     */
    'errorCode'?: string;
    /**
     * ID of the grid
     * @type {string}
     * @memberof GridStatus
     */
    'gridId'?: string;
}
/**
 * Grid summary with basic properties.
 * @export
 * @interface GridSummary
 */
export interface GridSummary {
    /**
     * Grid Id
     * @type {string}
     * @memberof GridSummary
     */
    'id'?: string;
    /**
     * Grid position
     * @type {number}
     * @memberof GridSummary
     */
    'position'?: number;
    /**
     * Grid visibility
     * @type {boolean}
     * @memberof GridSummary
     */
    'visible'?: boolean;
    /**
     * Grid description in all supported languages.
     * @type {Array<GridDescription>}
     * @memberof GridSummary
     */
    'descriptions'?: Array<GridDescription>;
}
/**
 * 
 * @export
 * @interface GridV2
 */
export interface GridV2 {
    /**
     * Grid Id
     * @type {string}
     * @memberof GridV2
     */
    'id'?: string;
    /**
     * The universe where it belongs
     * @type {number}
     * @memberof GridV2
     */
    'universeId'?: number;
    /**
     * Is Grid the default in the universe
     * @type {boolean}
     * @memberof GridV2
     */
    'defaultInUniverse'?: boolean;
    /**
     * 
     * @type {GridFilterDefinition}
     * @memberof GridV2
     */
    'filterDefinition'?: GridFilterDefinition;
    /**
     * Grid description in all supported languages.
     * @type {Array<GridDescription>}
     * @memberof GridV2
     */
    'descriptions': Array<GridDescription>;
    /**
     * Grid visibility on main menu
     * @type {boolean}
     * @memberof GridV2
     */
    'visible'?: boolean;
    /**
     * Grid recategorization excluded
     * @type {boolean}
     * @memberof GridV2
     */
    'recategorizationExcluded'?: boolean;
    /**
     * List of grid parents identifiers
     * @type {Array<Grid>}
     * @memberof GridV2
     */
    'subgrids'?: Array<Grid>;
    /**
     * List of grid parents identifiers
     * @type {Array<GridSummary>}
     * @memberof GridV2
     */
    'parentGrids'?: Array<GridSummary>;
    /**
     * The identifier of the external grid in Shopizer
     * @type {number}
     * @memberof GridV2
     */
    'externalGridId'?: number;
    /**
     * The grid filter
     * @type {string}
     * @memberof GridV2
     */
    'gridFilterId'?: string;
    /**
     * Grid published flag
     * @type {boolean}
     * @memberof GridV2
     */
    'isPublished'?: boolean;
    /**
     * URL of the mobile resource
     * @type {string}
     * @memberof GridV2
     */
    'mobileResourceUrl'?: string;
    /**
     * URL of the desktop resource
     * @type {string}
     * @memberof GridV2
     */
    'desktopResourceUrl'?: string;
    /**
     * The version of the grid
     * @type {number}
     * @memberof GridV2
     */
    'version'?: number;
    /**
     * The status of the grid
     * @type {string}
     * @memberof GridV2
     */
    'status'?: string;
    /**
     * The error code of the grid
     * @type {string}
     * @memberof GridV2
     */
    'errorCode'?: string;
    /**
     * The error message of the grid
     * @type {string}
     * @memberof GridV2
     */
    'errorMessage'?: string;
    /**
     * Flag to indicate if the grid is auto updatable
     * @type {boolean}
     * @memberof GridV2
     */
    'isAutoUpdatable'?: boolean;
    /**
     * ID of the store this grid filter is directed to
     * @type {number}
     * @memberof GridV2
     */
    'storeId': number;
    /**
     * ISO 639-1 code for the desired response language
     * @type {string}
     * @memberof GridV2
     */
    'lang'?: string;
}
/**
 * 
 * @export
 * @interface Gridfilter
 */
export interface Gridfilter {
    /**
     * List of all products
     * @type {Array<Product>}
     * @memberof Gridfilter
     */
    'products'?: Array<Product>;
    /**
     * 
     * @type {Criteria}
     * @memberof Gridfilter
     */
    'filterDefinition'?: Criteria;
}
/**
 * 
 * @export
 * @interface Gridfilters
 */
export interface Gridfilters {
    /**
     * 
     * @type {string}
     * @memberof Gridfilters
     */
    'operation'?: GridfiltersOperationEnum;
    /**
     * 
     * @type {GridfiltersV2Criteria}
     * @memberof Gridfilters
     */
    'criteria'?: GridfiltersV2Criteria;
    /**
     * Product IDs to be added or removed from the grid
     * @type {Array<number>}
     * @memberof Gridfilters
     */
    'products'?: Array<number>;
}

export const GridfiltersOperationEnum = {
    Add: 'ADD',
    Remove: 'REMOVE'
} as const;

export type GridfiltersOperationEnum = typeof GridfiltersOperationEnum[keyof typeof GridfiltersOperationEnum];

/**
 * 
 * @export
 * @interface GridfiltersV2
 */
export interface GridfiltersV2 {
    /**
     * ID of the store this grid filter is directed to
     * @type {number}
     * @memberof GridfiltersV2
     */
    'storeId': number;
    /**
     * ISO 639-1 code for the desired response language
     * @type {string}
     * @memberof GridfiltersV2
     */
    'lang'?: string;
    /**
     * 
     * @type {string}
     * @memberof GridfiltersV2
     */
    'operation'?: GridfiltersV2OperationEnum;
    /**
     * 
     * @type {GridfiltersV2Criteria}
     * @memberof GridfiltersV2
     */
    'criteria'?: GridfiltersV2Criteria;
    /**
     * Product IDs to be added or removed from the grid
     * @type {Array<number>}
     * @memberof GridfiltersV2
     */
    'products'?: Array<number>;
}

export const GridfiltersV2OperationEnum = {
    Add: 'ADD',
    Remove: 'REMOVE'
} as const;

export type GridfiltersV2OperationEnum = typeof GridfiltersV2OperationEnum[keyof typeof GridfiltersV2OperationEnum];

/**
 * 
 * @export
 * @interface GridfiltersV2Criteria
 */
export interface GridfiltersV2Criteria {
    /**
     * 
     * @type {Contents}
     * @memberof GridfiltersV2Criteria
     */
    'definition'?: Contents;
}
/**
 * @type ListGrids200Response
 * @export
 */
export type ListGrids200Response = { type: 'GridData' } & GridData | { type: 'GridIdData' } & GridIdData;

/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {object}
     * @memberof ModelError
     */
    'additionalData'?: object;
    /**
     * 
     * @type {number}
     * @memberof ModelError
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'detail'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface MoveGrid
 */
export interface MoveGrid {
    /**
     * New position of the grid in the list
     * @type {string}
     * @memberof MoveGrid
     */
    'sortRank'?: string;
}
/**
 * 
 * @export
 * @interface OptionContentFilter
 */
export interface OptionContentFilter {
    /**
     * Criterion type discriminator
     * @type {string}
     * @memberof OptionContentFilter
     */
    'type': string;
    /**
     * list of search values
     * @type {Array<number>}
     * @memberof OptionContentFilter
     */
    'values'?: Array<number>;
    /**
     * Product option type referred by this criterion
     * @type {string}
     * @memberof OptionContentFilter
     */
    'optionType'?: OptionContentFilterOptionTypeEnum;
}

export const OptionContentFilterOptionTypeEnum = {
    Color: 'COLOR',
    Size: 'SIZE',
    Condition: 'CONDITION'
} as const;

export type OptionContentFilterOptionTypeEnum = typeof OptionContentFilterOptionTypeEnum[keyof typeof OptionContentFilterOptionTypeEnum];

/**
 * 
 * @export
 * @interface OptionContentFilters
 */
export interface OptionContentFilters {
    /**
     * Criterion type discriminator
     * @type {string}
     * @memberof OptionContentFilters
     */
    'type': string;
    /**
     * list of search values
     * @type {Array<number>}
     * @memberof OptionContentFilters
     */
    'values'?: Array<number>;
    /**
     * Product option type referred by this criterion
     * @type {string}
     * @memberof OptionContentFilters
     */
    'optionType'?: OptionContentFiltersOptionTypeEnum;
}

export const OptionContentFiltersOptionTypeEnum = {
    Color: 'COLOR',
    Size: 'SIZE',
    Condition: 'CONDITION'
} as const;

export type OptionContentFiltersOptionTypeEnum = typeof OptionContentFiltersOptionTypeEnum[keyof typeof OptionContentFiltersOptionTypeEnum];

/**
 * Option-based filter criterion
 * @export
 * @interface OptionGridFilterCriterion
 */
export interface OptionGridFilterCriterion extends GridFilterCriterion {
    /**
     * Ids of the entities accepted by this filter
     * @type {Array<number>}
     * @memberof OptionGridFilterCriterion
     */
    'values'?: Array<number>;
    /**
     * Product option type referred by this criterion
     * @type {string}
     * @memberof OptionGridFilterCriterion
     */
    'optionType'?: OptionGridFilterCriterionOptionTypeEnum;
}

export const OptionGridFilterCriterionOptionTypeEnum = {
    Color: 'COLOR',
    Size: 'SIZE',
    Condition: 'CONDITION'
} as const;

export type OptionGridFilterCriterionOptionTypeEnum = typeof OptionGridFilterCriterionOptionTypeEnum[keyof typeof OptionGridFilterCriterionOptionTypeEnum];

/**
 * 
 * @export
 * @interface OptionGridFilterCriterionAllOf
 */
export interface OptionGridFilterCriterionAllOf {
    /**
     * Ids of the entities accepted by this filter
     * @type {Array<number>}
     * @memberof OptionGridFilterCriterionAllOf
     */
    'values'?: Array<number>;
    /**
     * Product option type referred by this criterion
     * @type {string}
     * @memberof OptionGridFilterCriterionAllOf
     */
    'optionType'?: OptionGridFilterCriterionAllOfOptionTypeEnum;
}

export const OptionGridFilterCriterionAllOfOptionTypeEnum = {
    Color: 'COLOR',
    Size: 'SIZE',
    Condition: 'CONDITION'
} as const;

export type OptionGridFilterCriterionAllOfOptionTypeEnum = typeof OptionGridFilterCriterionAllOfOptionTypeEnum[keyof typeof OptionGridFilterCriterionAllOfOptionTypeEnum];

/**
 * 
 * @export
 * @interface PageUniverseDto
 */
export interface PageUniverseDto {
    /**
     * Total number of elements
     * @type {number}
     * @memberof PageUniverseDto
     */
    'totalElements'?: number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof PageUniverseDto
     */
    'totalPages'?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageUniverseDto
     */
    'pageable'?: PageableObject;
    /**
     * first element
     * @type {boolean}
     * @memberof PageUniverseDto
     */
    'first'?: boolean;
    /**
     * last element
     * @type {boolean}
     * @memberof PageUniverseDto
     */
    'last'?: boolean;
    /**
     * size of the page
     * @type {number}
     * @memberof PageUniverseDto
     */
    'size'?: number;
    /**
     * 
     * @type {Array<UniversePublic>}
     * @memberof PageUniverseDto
     */
    'content'?: Array<UniversePublic>;
    /**
     * number of the page
     * @type {number}
     * @memberof PageUniverseDto
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageUniverseDto
     */
    'sort'?: Sort;
    /**
     * number of elements
     * @type {number}
     * @memberof PageUniverseDto
     */
    'numberOfElements'?: number;
    /**
     * empty
     * @type {boolean}
     * @memberof PageUniverseDto
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
    /**
     * size of the page
     * @type {number}
     * @memberof PageableObject
     */
    'pageSize'?: number;
    /**
     * number of the page
     * @type {number}
     * @memberof PageableObject
     */
    'pageNumber'?: number;
    /**
     * offset
     * @type {number}
     * @memberof PageableObject
     */
    'offset'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageableObject
     */
    'sort'?: Sort;
    /**
     * paged
     * @type {boolean}
     * @memberof PageableObject
     */
    'paged'?: boolean;
    /**
     * unpaged
     * @type {boolean}
     * @memberof PageableObject
     */
    'unpaged'?: boolean;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * Product group Id
     * @type {number}
     * @memberof Product
     */
    'productGroupId'?: number;
}
/**
 * 
 * @export
 * @interface ProductGroup
 */
export interface ProductGroup {
    /**
     * Product group IDs to be removed from the grid
     * @type {Array<number>}
     * @memberof ProductGroup
     */
    'removedProducts'?: Array<number>;
}
/**
 * 
 * @export
 * @interface ProductOut
 */
export interface ProductOut {
    /**
     * 
     * @type {string}
     * @memberof ProductOut
     */
    'gridId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductOut
     */
    'outOfDate'?: boolean;
}
/**
 * 
 * @export
 * @interface SearchContentFilter
 */
export interface SearchContentFilter {
    /**
     * Criterion type discriminator
     * @type {string}
     * @memberof SearchContentFilter
     */
    'type': string;
    /**
     * List of the entire definition of search type filters
     * @type {Array<SearchesFilter>}
     * @memberof SearchContentFilter
     */
    'values'?: Array<SearchesFilter>;
}
/**
 * 
 * @export
 * @interface SearchContentFilters
 */
export interface SearchContentFilters {
    /**
     * Search Criterion type discriminator
     * @type {string}
     * @memberof SearchContentFilters
     */
    'type': string;
    /**
     * Type of operation
     * @type {string}
     * @memberof SearchContentFilters
     */
    'operation'?: string;
    /**
     * Search engine end
     * @type {string}
     * @memberof SearchContentFilters
     */
    'term'?: string;
}
/**
 * IA Search-based filter criterion
 * @export
 * @interface SearchGridFilterCriterion
 */
export interface SearchGridFilterCriterion extends GridFilterCriterion {
    /**
     * Search term
     * @type {string}
     * @memberof SearchGridFilterCriterion
     */
    'searchTerm': string;
    /**
     * Search operation type
     * @type {string}
     * @memberof SearchGridFilterCriterion
     */
    'searchOperation': SearchGridFilterCriterionSearchOperationEnum;
    /**
     * Ids of the searched products
     * @type {Array<number>}
     * @memberof SearchGridFilterCriterion
     */
    'searchedProductGroups'?: Array<number>;
    /**
     * Hash of the searched products
     * @type {string}
     * @memberof SearchGridFilterCriterion
     */
    'searchedProductGroupsHash'?: string;
}

export const SearchGridFilterCriterionSearchOperationEnum = {
    Include: 'INCLUDE',
    Exclude: 'EXCLUDE',
    ExcludeManual: 'EXCLUDE_MANUAL'
} as const;

export type SearchGridFilterCriterionSearchOperationEnum = typeof SearchGridFilterCriterionSearchOperationEnum[keyof typeof SearchGridFilterCriterionSearchOperationEnum];

/**
 * 
 * @export
 * @interface SearchGridFilterCriterionAllOf
 */
export interface SearchGridFilterCriterionAllOf {
    /**
     * Search term
     * @type {string}
     * @memberof SearchGridFilterCriterionAllOf
     */
    'searchTerm': string;
    /**
     * Search operation type
     * @type {string}
     * @memberof SearchGridFilterCriterionAllOf
     */
    'searchOperation': SearchGridFilterCriterionAllOfSearchOperationEnum;
    /**
     * Ids of the searched products
     * @type {Array<number>}
     * @memberof SearchGridFilterCriterionAllOf
     */
    'searchedProductGroups'?: Array<number>;
    /**
     * Hash of the searched products
     * @type {string}
     * @memberof SearchGridFilterCriterionAllOf
     */
    'searchedProductGroupsHash'?: string;
}

export const SearchGridFilterCriterionAllOfSearchOperationEnum = {
    Include: 'INCLUDE',
    Exclude: 'EXCLUDE',
    ExcludeManual: 'EXCLUDE_MANUAL'
} as const;

export type SearchGridFilterCriterionAllOfSearchOperationEnum = typeof SearchGridFilterCriterionAllOfSearchOperationEnum[keyof typeof SearchGridFilterCriterionAllOfSearchOperationEnum];

/**
 * 
 * @export
 * @interface SearchesFilter
 */
export interface SearchesFilter {
    /**
     * Type of operation
     * @type {string}
     * @memberof SearchesFilter
     */
    'operation'?: string;
    /**
     * Search engine end
     * @type {string}
     * @memberof SearchesFilter
     */
    'term'?: string;
    /**
     * Ids of the found products
     * @type {Array<number>}
     * @memberof SearchesFilter
     */
    'foundProducts'?: Array<number>;
}
/**
 * 
 * @export
 * @interface Sort
 */
export interface Sort {
    /**
     * sorted
     * @type {boolean}
     * @memberof Sort
     */
    'sorted'?: boolean;
    /**
     * empty
     * @type {boolean}
     * @memberof Sort
     */
    'empty'?: boolean;
    /**
     * unsorted
     * @type {boolean}
     * @memberof Sort
     */
    'unsorted'?: boolean;
}
/**
 * 
 * @export
 * @interface UniversePublic
 */
export interface UniversePublic {
    /**
     * universe id
     * @type {number}
     * @memberof UniversePublic
     */
    'id'?: number;
    /**
     * universe name
     * @type {string}
     * @memberof UniversePublic
     */
    'name'?: string;
    /**
     * universe title
     * @type {string}
     * @memberof UniversePublic
     */
    'title'?: string;
    /**
     * universe description
     * @type {string}
     * @memberof UniversePublic
     */
    'description'?: string;
    /**
     * universe categories
     * @type {Array<number>}
     * @memberof UniversePublic
     */
    'categories'?: Array<number>;
    /**
     * universe rank
     * @type {string}
     * @memberof UniversePublic
     */
    'rank'?: string;
    /**
     * universe default flag
     * @type {boolean}
     * @memberof UniversePublic
     */
    'isDefault'?: boolean;
    /**
     * universe grids
     * @type {Array<GridPublic>}
     * @memberof UniversePublic
     */
    'grids'?: Array<GridPublic>;
}

/**
 * GridEngineAdminApi - axios parameter creator
 * @export
 */
export const GridEngineAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/children` instead.
         * @summary Assign subgrids to a grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<string>} requestBody Array of grid IDs to assign as children
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignSubgrids: async (gridId: string, storeId: number, requestBody: Array<string>, userId?: string, userToken?: string, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('assignSubgrids', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('assignSubgrids', 'storeId', storeId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('assignSubgrids', 'requestBody', requestBody)
            const localVarPath = `/api/v3/admin/grids/{gridId}/children`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (userId != null) {
                localVarHeaderParameter['user-id'] = String(userId);
            }

            if (userToken != null) {
                localVarHeaderParameter['user-token'] = String(userToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids` instead. This endpoint creates a new grid.
         * @summary Create a new grid
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid to create
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createGrid: async (storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('createGrid', 'storeId', storeId)
            // verify required parameter 'grid' is not null or undefined
            assertParamExists('createGrid', 'grid', grid)
            const localVarPath = `/api/v3/admin/grids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (userId != null) {
                localVarHeaderParameter['user-id'] = String(userId);
            }

            if (userToken != null) {
                localVarHeaderParameter['user-token'] = String(userToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
         * @summary Delete a grid
         * @param {string} gridId ID of the grid to delete
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteGrid: async (gridId: string, storeId: number, userId?: string, userToken?: string, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('deleteGrid', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('deleteGrid', 'storeId', storeId)
            const localVarPath = `/api/v3/admin/grids/{gridId}`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (userId != null) {
                localVarHeaderParameter['user-id'] = String(userId);
            }

            if (userToken != null) {
                localVarHeaderParameter['user-token'] = String(userToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/outdated` instead
         * @summary Request to evaluate products as outdated
         * @param {string} gridId Grid ID
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        evaluateProduct: async (gridId: string, storeId: number, lang?: string, userId?: string, userToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('evaluateProduct', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('evaluateProduct', 'storeId', storeId)
            const localVarPath = `/api/v3/admin/{gridId}/outdated`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (userId != null) {
                localVarHeaderParameter['user-id'] = String(userId);
            }

            if (userToken != null) {
                localVarHeaderParameter['user-token'] = String(userToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
         * @summary Get grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getGrid: async (gridId: string, storeId: number, userId?: string, userToken?: string, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('getGrid', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getGrid', 'storeId', storeId)
            const localVarPath = `/api/v3/admin/grids/{gridId}`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (userId != null) {
                localVarHeaderParameter['user-id'] = String(userId);
            }

            if (userToken != null) {
                localVarHeaderParameter['user-token'] = String(userToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/status` instead.
         * @summary Get grid status
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getGridStatus: async (gridId: string, storeId: number, universeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('getGridStatus', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getGridStatus', 'storeId', storeId)
            // verify required parameter 'universeId' is not null or undefined
            assertParamExists('getGridStatus', 'universeId', universeId)
            const localVarPath = `/api/v3/admin/grids/{gridId}/status`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (universeId !== undefined) {
                localVarQueryParameter['universeId'] = universeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids` instead.
         * @summary List grids
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {number} [universeId] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {boolean} [showOnlyParents] Flag to filter by available parents
         * @param {boolean} [onlyIds] Flag to return only grid IDs
         * @param {boolean} [updatable] Flag to filter grids that can be updated
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listGrids: async (storeId: number, userId?: string, userToken?: string, universeId?: number, lang?: string, showOnlyParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listGrids', 'storeId', storeId)
            const localVarPath = `/api/v3/admin/grids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (universeId !== undefined) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (showOnlyParents !== undefined) {
                localVarQueryParameter['showOnlyParents'] = showOnlyParents;
            }

            if (onlyIds !== undefined) {
                localVarQueryParameter['onlyIds'] = onlyIds;
            }

            if (updatable !== undefined) {
                localVarQueryParameter['updatable'] = updatable;
            }

            if (version) {
                localVarQueryParameter['version'] = version;
            }

            if (userId != null) {
                localVarHeaderParameter['user-id'] = String(userId);
            }

            if (userToken != null) {
                localVarHeaderParameter['user-token'] = String(userToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
         * @summary Patch grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid object to update
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchGrid: async (gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('patchGrid', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('patchGrid', 'storeId', storeId)
            // verify required parameter 'grid' is not null or undefined
            assertParamExists('patchGrid', 'grid', grid)
            const localVarPath = `/api/v3/admin/grids/{gridId}`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (userId != null) {
                localVarHeaderParameter['user-id'] = String(userId);
            }

            if (userToken != null) {
                localVarHeaderParameter['user-token'] = String(userToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/1234/move` instead.
         * @summary Patch grid for moving position grids
         * @param {number} shopizerGridId Shopizer grid ID to move
         * @param {MoveGrid} moveGrid Grid object to update
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchMoveGrid: async (shopizerGridId: number, moveGrid: MoveGrid, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopizerGridId' is not null or undefined
            assertParamExists('patchMoveGrid', 'shopizerGridId', shopizerGridId)
            // verify required parameter 'moveGrid' is not null or undefined
            assertParamExists('patchMoveGrid', 'moveGrid', moveGrid)
            const localVarPath = `/api/v3/admin/grids/{shopizerGridId}/move`
                .replace(`{${"shopizerGridId"}}`, encodeURIComponent(String(shopizerGridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveGrid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/clone` instead.
         * @summary Clone grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid object to update
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postCloneGrid: async (gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('postCloneGrid', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('postCloneGrid', 'storeId', storeId)
            // verify required parameter 'grid' is not null or undefined
            assertParamExists('postCloneGrid', 'grid', grid)
            const localVarPath = `/api/v3/admin/grids/{gridId}/clone`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (userId != null) {
                localVarHeaderParameter['user-id'] = String(userId);
            }

            if (userToken != null) {
                localVarHeaderParameter['user-token'] = String(userToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
         * @summary Put grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid object to update
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putGrid: async (gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('putGrid', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('putGrid', 'storeId', storeId)
            // verify required parameter 'grid' is not null or undefined
            assertParamExists('putGrid', 'grid', grid)
            const localVarPath = `/api/v3/admin/grids/{gridId}`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (userId != null) {
                localVarHeaderParameter['user-id'] = String(userId);
            }

            if (userToken != null) {
                localVarHeaderParameter['user-token'] = String(userToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GridEngineAdminApi - functional programming interface
 * @export
 */
export const GridEngineAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GridEngineAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/children` instead.
         * @summary Assign subgrids to a grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<string>} requestBody Array of grid IDs to assign as children
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async assignSubgrids(gridId: string, storeId: number, requestBody: Array<string>, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignSubgrids(gridId, storeId, requestBody, userId, userToken, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids` instead. This endpoint creates a new grid.
         * @summary Create a new grid
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid to create
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async createGrid(storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGrid(storeId, grid, userId, userToken, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
         * @summary Delete a grid
         * @param {string} gridId ID of the grid to delete
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async deleteGrid(gridId: string, storeId: number, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGrid(gridId, storeId, userId, userToken, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/outdated` instead
         * @summary Request to evaluate products as outdated
         * @param {string} gridId Grid ID
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async evaluateProduct(gridId: string, storeId: number, lang?: string, userId?: string, userToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evaluateProduct(gridId, storeId, lang, userId, userToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
         * @summary Get grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getGrid(gridId: string, storeId: number, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGrid(gridId, storeId, userId, userToken, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/status` instead.
         * @summary Get grid status
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getGridStatus(gridId: string, storeId: number, universeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGridStatus(gridId, storeId, universeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids` instead.
         * @summary List grids
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {number} [universeId] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {boolean} [showOnlyParents] Flag to filter by available parents
         * @param {boolean} [onlyIds] Flag to return only grid IDs
         * @param {boolean} [updatable] Flag to filter grids that can be updated
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async listGrids(storeId: number, userId?: string, userToken?: string, universeId?: number, lang?: string, showOnlyParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListGrids200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGrids(storeId, userId, userToken, universeId, lang, showOnlyParents, onlyIds, updatable, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
         * @summary Patch grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid object to update
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async patchGrid(gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchGrid(gridId, storeId, grid, userId, userToken, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/1234/move` instead.
         * @summary Patch grid for moving position grids
         * @param {number} shopizerGridId Shopizer grid ID to move
         * @param {MoveGrid} moveGrid Grid object to update
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async patchMoveGrid(shopizerGridId: number, moveGrid: MoveGrid, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchMoveGrid(shopizerGridId, moveGrid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/clone` instead.
         * @summary Clone grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid object to update
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async postCloneGrid(gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCloneGrid(gridId, storeId, grid, userId, userToken, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
         * @summary Put grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid object to update
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async putGrid(gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putGrid(gridId, storeId, grid, userId, userToken, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GridEngineAdminApi - factory interface
 * @export
 */
export const GridEngineAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GridEngineAdminApiFp(configuration)
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/children` instead.
         * @summary Assign subgrids to a grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<string>} requestBody Array of grid IDs to assign as children
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        assignSubgrids(gridId: string, storeId: number, requestBody: Array<string>, userId?: string, userToken?: string, lang?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.assignSubgrids(gridId, storeId, requestBody, userId, userToken, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids` instead. This endpoint creates a new grid.
         * @summary Create a new grid
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid to create
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createGrid(storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.createGrid(storeId, grid, userId, userToken, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
         * @summary Delete a grid
         * @param {string} gridId ID of the grid to delete
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteGrid(gridId: string, storeId: number, userId?: string, userToken?: string, lang?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteGrid(gridId, storeId, userId, userToken, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/outdated` instead
         * @summary Request to evaluate products as outdated
         * @param {string} gridId Grid ID
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        evaluateProduct(gridId: string, storeId: number, lang?: string, userId?: string, userToken?: string, options?: any): AxiosPromise<ProductOut> {
            return localVarFp.evaluateProduct(gridId, storeId, lang, userId, userToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
         * @summary Get grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getGrid(gridId: string, storeId: number, userId?: string, userToken?: string, lang?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.getGrid(gridId, storeId, userId, userToken, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/status` instead.
         * @summary Get grid status
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getGridStatus(gridId: string, storeId: number, universeId: number, lang?: string, options?: any): AxiosPromise<GridStatus> {
            return localVarFp.getGridStatus(gridId, storeId, universeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids` instead.
         * @summary List grids
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {number} [universeId] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {boolean} [showOnlyParents] Flag to filter by available parents
         * @param {boolean} [onlyIds] Flag to return only grid IDs
         * @param {boolean} [updatable] Flag to filter grids that can be updated
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listGrids(storeId: number, userId?: string, userToken?: string, universeId?: number, lang?: string, showOnlyParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options?: any): AxiosPromise<ListGrids200Response> {
            return localVarFp.listGrids(storeId, userId, userToken, universeId, lang, showOnlyParents, onlyIds, updatable, version, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
         * @summary Patch grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid object to update
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchGrid(gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.patchGrid(gridId, storeId, grid, userId, userToken, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/1234/move` instead.
         * @summary Patch grid for moving position grids
         * @param {number} shopizerGridId Shopizer grid ID to move
         * @param {MoveGrid} moveGrid Grid object to update
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchMoveGrid(shopizerGridId: number, moveGrid: MoveGrid, options?: any): AxiosPromise<Grid> {
            return localVarFp.patchMoveGrid(shopizerGridId, moveGrid, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/clone` instead.
         * @summary Clone grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid object to update
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postCloneGrid(gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.postCloneGrid(gridId, storeId, grid, userId, userToken, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
         * @summary Put grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid object to update
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putGrid(gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.putGrid(gridId, storeId, grid, userId, userToken, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GridEngineAdminApi - interface
 * @export
 * @interface GridEngineAdminApi
 */
export interface GridEngineAdminApiInterface {
    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/children` instead.
     * @summary Assign subgrids to a grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<string>} requestBody Array of grid IDs to assign as children
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApiInterface
     */
    assignSubgrids(gridId: string, storeId: number, requestBody: Array<string>, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids` instead. This endpoint creates a new grid.
     * @summary Create a new grid
     * @param {number} storeId ID of the store this query is directed to
     * @param {Grid} grid Grid to create
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApiInterface
     */
    createGrid(storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
     * @summary Delete a grid
     * @param {string} gridId ID of the grid to delete
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApiInterface
     */
    deleteGrid(gridId: string, storeId: number, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/outdated` instead
     * @summary Request to evaluate products as outdated
     * @param {string} gridId Grid ID
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApiInterface
     */
    evaluateProduct(gridId: string, storeId: number, lang?: string, userId?: string, userToken?: string, options?: AxiosRequestConfig): AxiosPromise<ProductOut>;

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
     * @summary Get grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApiInterface
     */
    getGrid(gridId: string, storeId: number, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/status` instead.
     * @summary Get grid status
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} universeId Universe ID to search in
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApiInterface
     */
    getGridStatus(gridId: string, storeId: number, universeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<GridStatus>;

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids` instead.
     * @summary List grids
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {number} [universeId] 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {boolean} [showOnlyParents] Flag to filter by available parents
     * @param {boolean} [onlyIds] Flag to return only grid IDs
     * @param {boolean} [updatable] Flag to filter grids that can be updated
     * @param {Array<number>} [version] List of grid versions to filter
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApiInterface
     */
    listGrids(storeId: number, userId?: string, userToken?: string, universeId?: number, lang?: string, showOnlyParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options?: AxiosRequestConfig): AxiosPromise<ListGrids200Response>;

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
     * @summary Patch grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {Grid} grid Grid object to update
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApiInterface
     */
    patchGrid(gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/1234/move` instead.
     * @summary Patch grid for moving position grids
     * @param {number} shopizerGridId Shopizer grid ID to move
     * @param {MoveGrid} moveGrid Grid object to update
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApiInterface
     */
    patchMoveGrid(shopizerGridId: number, moveGrid: MoveGrid, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/clone` instead.
     * @summary Clone grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {Grid} grid Grid object to update
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApiInterface
     */
    postCloneGrid(gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
     * @summary Put grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {Grid} grid Grid object to update
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApiInterface
     */
    putGrid(gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

}

/**
 * GridEngineAdminApi - object-oriented interface
 * @export
 * @class GridEngineAdminApi
 * @extends {BaseAPI}
 */
export class GridEngineAdminApi extends BaseAPI implements GridEngineAdminApiInterface {
    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/children` instead.
     * @summary Assign subgrids to a grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<string>} requestBody Array of grid IDs to assign as children
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApi
     */
    public assignSubgrids(gridId: string, storeId: number, requestBody: Array<string>, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig) {
        return GridEngineAdminApiFp(this.configuration).assignSubgrids(gridId, storeId, requestBody, userId, userToken, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids` instead. This endpoint creates a new grid.
     * @summary Create a new grid
     * @param {number} storeId ID of the store this query is directed to
     * @param {Grid} grid Grid to create
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApi
     */
    public createGrid(storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig) {
        return GridEngineAdminApiFp(this.configuration).createGrid(storeId, grid, userId, userToken, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
     * @summary Delete a grid
     * @param {string} gridId ID of the grid to delete
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApi
     */
    public deleteGrid(gridId: string, storeId: number, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig) {
        return GridEngineAdminApiFp(this.configuration).deleteGrid(gridId, storeId, userId, userToken, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/outdated` instead
     * @summary Request to evaluate products as outdated
     * @param {string} gridId Grid ID
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApi
     */
    public evaluateProduct(gridId: string, storeId: number, lang?: string, userId?: string, userToken?: string, options?: AxiosRequestConfig) {
        return GridEngineAdminApiFp(this.configuration).evaluateProduct(gridId, storeId, lang, userId, userToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
     * @summary Get grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApi
     */
    public getGrid(gridId: string, storeId: number, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig) {
        return GridEngineAdminApiFp(this.configuration).getGrid(gridId, storeId, userId, userToken, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/status` instead.
     * @summary Get grid status
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} universeId Universe ID to search in
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApi
     */
    public getGridStatus(gridId: string, storeId: number, universeId: number, lang?: string, options?: AxiosRequestConfig) {
        return GridEngineAdminApiFp(this.configuration).getGridStatus(gridId, storeId, universeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids` instead.
     * @summary List grids
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {number} [universeId] 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {boolean} [showOnlyParents] Flag to filter by available parents
     * @param {boolean} [onlyIds] Flag to return only grid IDs
     * @param {boolean} [updatable] Flag to filter grids that can be updated
     * @param {Array<number>} [version] List of grid versions to filter
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApi
     */
    public listGrids(storeId: number, userId?: string, userToken?: string, universeId?: number, lang?: string, showOnlyParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options?: AxiosRequestConfig) {
        return GridEngineAdminApiFp(this.configuration).listGrids(storeId, userId, userToken, universeId, lang, showOnlyParents, onlyIds, updatable, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
     * @summary Patch grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {Grid} grid Grid object to update
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApi
     */
    public patchGrid(gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig) {
        return GridEngineAdminApiFp(this.configuration).patchGrid(gridId, storeId, grid, userId, userToken, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/1234/move` instead.
     * @summary Patch grid for moving position grids
     * @param {number} shopizerGridId Shopizer grid ID to move
     * @param {MoveGrid} moveGrid Grid object to update
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApi
     */
    public patchMoveGrid(shopizerGridId: number, moveGrid: MoveGrid, options?: AxiosRequestConfig) {
        return GridEngineAdminApiFp(this.configuration).patchMoveGrid(shopizerGridId, moveGrid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/clone` instead.
     * @summary Clone grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {Grid} grid Grid object to update
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApi
     */
    public postCloneGrid(gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig) {
        return GridEngineAdminApiFp(this.configuration).postCloneGrid(gridId, storeId, grid, userId, userToken, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ` instead.
     * @summary Put grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {Grid} grid Grid object to update
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineAdminApi
     */
    public putGrid(gridId: string, storeId: number, grid: Grid, userId?: string, userToken?: string, lang?: string, options?: AxiosRequestConfig) {
        return GridEngineAdminApiFp(this.configuration).putGrid(gridId, storeId, grid, userId, userToken, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GridEngineInternalAPIApi - axios parameter creator
 * @export
 */
export const GridEngineInternalAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/find-updatable` instead.
         * @summary Gets the list of candidate grids for automatic update
         * @param {number} storeId Store ID
         * @param {number} [universeId] Universe ID
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findUpdatableGrids: async (storeId: number, universeId?: number, version?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('findUpdatableGrids', 'storeId', storeId)
            const localVarPath = `/api/v3/internal/grids/find-updatable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (universeId !== undefined) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (version) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/outdated` instead.
         * @summary Checks if a grid is outdated and requires updating
         * @param {string} gridId Grid ID
         * @param {number} storeId Store ID
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        isGridOutdated: async (gridId: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('isGridOutdated', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('isGridOutdated', 'storeId', storeId)
            const localVarPath = `/api/v3/internal/grids/{gridId}/outdated`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GridEngineInternalAPIApi - functional programming interface
 * @export
 */
export const GridEngineInternalAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GridEngineInternalAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/find-updatable` instead.
         * @summary Gets the list of candidate grids for automatic update
         * @param {number} storeId Store ID
         * @param {number} [universeId] Universe ID
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async findUpdatableGrids(storeId: number, universeId?: number, version?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridIdData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUpdatableGrids(storeId, universeId, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/outdated` instead.
         * @summary Checks if a grid is outdated and requires updating
         * @param {string} gridId Grid ID
         * @param {number} storeId Store ID
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async isGridOutdated(gridId: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridOutdated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isGridOutdated(gridId, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GridEngineInternalAPIApi - factory interface
 * @export
 */
export const GridEngineInternalAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GridEngineInternalAPIApiFp(configuration)
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/find-updatable` instead.
         * @summary Gets the list of candidate grids for automatic update
         * @param {number} storeId Store ID
         * @param {number} [universeId] Universe ID
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findUpdatableGrids(storeId: number, universeId?: number, version?: Array<number>, options?: any): AxiosPromise<GridIdData> {
            return localVarFp.findUpdatableGrids(storeId, universeId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/outdated` instead.
         * @summary Checks if a grid is outdated and requires updating
         * @param {string} gridId Grid ID
         * @param {number} storeId Store ID
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        isGridOutdated(gridId: string, storeId: number, lang?: string, options?: any): AxiosPromise<GridOutdated> {
            return localVarFp.isGridOutdated(gridId, storeId, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GridEngineInternalAPIApi - interface
 * @export
 * @interface GridEngineInternalAPIApi
 */
export interface GridEngineInternalAPIApiInterface {
    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/find-updatable` instead.
     * @summary Gets the list of candidate grids for automatic update
     * @param {number} storeId Store ID
     * @param {number} [universeId] Universe ID
     * @param {Array<number>} [version] List of grid versions to filter
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineInternalAPIApiInterface
     */
    findUpdatableGrids(storeId: number, universeId?: number, version?: Array<number>, options?: AxiosRequestConfig): AxiosPromise<GridIdData>;

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/outdated` instead.
     * @summary Checks if a grid is outdated and requires updating
     * @param {string} gridId Grid ID
     * @param {number} storeId Store ID
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineInternalAPIApiInterface
     */
    isGridOutdated(gridId: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<GridOutdated>;

}

/**
 * GridEngineInternalAPIApi - object-oriented interface
 * @export
 * @class GridEngineInternalAPIApi
 * @extends {BaseAPI}
 */
export class GridEngineInternalAPIApi extends BaseAPI implements GridEngineInternalAPIApiInterface {
    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/find-updatable` instead.
     * @summary Gets the list of candidate grids for automatic update
     * @param {number} storeId Store ID
     * @param {number} [universeId] Universe ID
     * @param {Array<number>} [version] List of grid versions to filter
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineInternalAPIApi
     */
    public findUpdatableGrids(storeId: number, universeId?: number, version?: Array<number>, options?: AxiosRequestConfig) {
        return GridEngineInternalAPIApiFp(this.configuration).findUpdatableGrids(storeId, universeId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-stp/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/outdated` instead.
     * @summary Checks if a grid is outdated and requires updating
     * @param {string} gridId Grid ID
     * @param {number} storeId Store ID
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridEngineInternalAPIApi
     */
    public isGridOutdated(gridId: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return GridEngineInternalAPIApiFp(this.configuration).isGridOutdated(gridId, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GridEnginePrivateApi - axios parameter creator
 * @export
 */
export const GridEnginePrivateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assigns subgrids to a parent grid
         * @summary Assign subgrids to a grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {Array<string>} requestBody Array of grid IDs to assign as children
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignSubgridsPvt: async (gridId: string, requestBody: Array<string>, userName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('assignSubgridsPvt', 'gridId', gridId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('assignSubgridsPvt', 'requestBody', requestBody)
            const localVarPath = `/api/preowned-pvt/v3/grids/{gridId}/children`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userName != null) {
                localVarHeaderParameter['user-name'] = String(userName);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new grid with the provided details
         * @summary Create a new grid
         * @param {GridV2} gridV2 Grid to create
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGridPvt: async (gridV2: GridV2, userName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridV2' is not null or undefined
            assertParamExists('createGridPvt', 'gridV2', gridV2)
            const localVarPath = `/api/preowned-pvt/v3/grids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userName != null) {
                localVarHeaderParameter['user-name'] = String(userName);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gridV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a grid by its ID
         * @summary Delete a grid
         * @param {string} gridId ID of the grid to delete
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGridPvt: async (gridId: string, userName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('deleteGridPvt', 'gridId', gridId)
            const localVarPath = `/api/preowned-pvt/v3/grids/{gridId}`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userName != null) {
                localVarHeaderParameter['user-name'] = String(userName);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a grid by its ID
         * @summary Get grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridPvt: async (gridId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('getGridPvt', 'gridId', gridId)
            const localVarPath = `/api/preowned-pvt/v3/grids/{gridId}`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the status of a grid by its ID
         * @summary Get grid status
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridStatusPvt: async (gridId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('getGridStatusPvt', 'gridId', gridId)
            const localVarPath = `/api/preowned-pvt/v3/grids/{gridId}/status`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of grids based on provided filters
         * @summary List grids
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [universeId] Universe ID to filter grids
         * @param {boolean} [hasParents] Flag to filter by available parents
         * @param {boolean} [onlyIds] Flag to return only grid IDs
         * @param {boolean} [updatable] Flag to filter grids that can be updated
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGridsPvt: async (storeId: number, universeId?: number, hasParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listGridsPvt', 'storeId', storeId)
            const localVarPath = `/api/preowned-pvt/v3/grids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (universeId !== undefined) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (hasParents !== undefined) {
                localVarQueryParameter['hasParents'] = hasParents;
            }

            if (onlyIds !== undefined) {
                localVarQueryParameter['onlyIds'] = onlyIds;
            }

            if (updatable !== undefined) {
                localVarQueryParameter['updatable'] = updatable;
            }

            if (version) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move a grid position up or down within its parent\'s children list
         * @summary Patch grid for moving position grids
         * @param {number} shopizerGridId Shopizer grid ID to move
         * @param {MoveGrid} moveGrid Grid object to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMoveGridPvt: async (shopizerGridId: number, moveGrid: MoveGrid, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopizerGridId' is not null or undefined
            assertParamExists('patchMoveGridPvt', 'shopizerGridId', shopizerGridId)
            // verify required parameter 'moveGrid' is not null or undefined
            assertParamExists('patchMoveGridPvt', 'moveGrid', moveGrid)
            const localVarPath = `/api/preowned-pvt/v3/grids/{shopizerGridId}/move`
                .replace(`{${"shopizerGridId"}}`, encodeURIComponent(String(shopizerGridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveGrid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clones an existing grid, creating a new grid with the same properties
         * @summary Clone grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {GridV2} gridV2 Grid object to update
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCloneGridPvt: async (gridId: string, gridV2: GridV2, userName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('postCloneGridPvt', 'gridId', gridId)
            // verify required parameter 'gridV2' is not null or undefined
            assertParamExists('postCloneGridPvt', 'gridV2', gridV2)
            const localVarPath = `/api/preowned-pvt/v3/grids/{gridId}/clone`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userName != null) {
                localVarHeaderParameter['user-name'] = String(userName);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gridV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing grid by its ID
         * @summary Put grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {Grid} grid Grid object to update
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGridPvt: async (gridId: string, grid: Grid, userName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('putGridPvt', 'gridId', gridId)
            // verify required parameter 'grid' is not null or undefined
            assertParamExists('putGridPvt', 'grid', grid)
            const localVarPath = `/api/preowned-pvt/v3/grids/{gridId}`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userName != null) {
                localVarHeaderParameter['user-name'] = String(userName);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request to remove and add product group ids
         * @summary Update product group ids
         * @param {string} gridId Grid ID
         * @param {ProductGroup} productGroup services object
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductGroup: async (gridId: string, productGroup: ProductGroup, userName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('updateProductGroup', 'gridId', gridId)
            // verify required parameter 'productGroup' is not null or undefined
            assertParamExists('updateProductGroup', 'productGroup', productGroup)
            const localVarPath = `/api/preowned-pvt/v3/grids/{gridId}/group`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userName != null) {
                localVarHeaderParameter['user-name'] = String(userName);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productGroup, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GridEnginePrivateApi - functional programming interface
 * @export
 */
export const GridEnginePrivateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GridEnginePrivateApiAxiosParamCreator(configuration)
    return {
        /**
         * Assigns subgrids to a parent grid
         * @summary Assign subgrids to a grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {Array<string>} requestBody Array of grid IDs to assign as children
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignSubgridsPvt(gridId: string, requestBody: Array<string>, userName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignSubgridsPvt(gridId, requestBody, userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new grid with the provided details
         * @summary Create a new grid
         * @param {GridV2} gridV2 Grid to create
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGridPvt(gridV2: GridV2, userName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGridPvt(gridV2, userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes a grid by its ID
         * @summary Delete a grid
         * @param {string} gridId ID of the grid to delete
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGridPvt(gridId: string, userName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGridPvt(gridId, userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a grid by its ID
         * @summary Get grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGridPvt(gridId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGridPvt(gridId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the status of a grid by its ID
         * @summary Get grid status
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGridStatusPvt(gridId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGridStatusPvt(gridId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves a list of grids based on provided filters
         * @summary List grids
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [universeId] Universe ID to filter grids
         * @param {boolean} [hasParents] Flag to filter by available parents
         * @param {boolean} [onlyIds] Flag to return only grid IDs
         * @param {boolean} [updatable] Flag to filter grids that can be updated
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGridsPvt(storeId: number, universeId?: number, hasParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListGrids200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGridsPvt(storeId, universeId, hasParents, onlyIds, updatable, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Move a grid position up or down within its parent\'s children list
         * @summary Patch grid for moving position grids
         * @param {number} shopizerGridId Shopizer grid ID to move
         * @param {MoveGrid} moveGrid Grid object to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchMoveGridPvt(shopizerGridId: number, moveGrid: MoveGrid, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchMoveGridPvt(shopizerGridId, moveGrid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Clones an existing grid, creating a new grid with the same properties
         * @summary Clone grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {GridV2} gridV2 Grid object to update
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCloneGridPvt(gridId: string, gridV2: GridV2, userName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCloneGridPvt(gridId, gridV2, userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates an existing grid by its ID
         * @summary Put grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {Grid} grid Grid object to update
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putGridPvt(gridId: string, grid: Grid, userName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putGridPvt(gridId, grid, userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Request to remove and add product group ids
         * @summary Update product group ids
         * @param {string} gridId Grid ID
         * @param {ProductGroup} productGroup services object
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductGroup(gridId: string, productGroup: ProductGroup, userName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductGroup(gridId, productGroup, userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GridEnginePrivateApi - factory interface
 * @export
 */
export const GridEnginePrivateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GridEnginePrivateApiFp(configuration)
    return {
        /**
         * Assigns subgrids to a parent grid
         * @summary Assign subgrids to a grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {Array<string>} requestBody Array of grid IDs to assign as children
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignSubgridsPvt(gridId: string, requestBody: Array<string>, userName?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.assignSubgridsPvt(gridId, requestBody, userName, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new grid with the provided details
         * @summary Create a new grid
         * @param {GridV2} gridV2 Grid to create
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGridPvt(gridV2: GridV2, userName?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.createGridPvt(gridV2, userName, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a grid by its ID
         * @summary Delete a grid
         * @param {string} gridId ID of the grid to delete
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGridPvt(gridId: string, userName?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteGridPvt(gridId, userName, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a grid by its ID
         * @summary Get grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridPvt(gridId: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.getGridPvt(gridId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the status of a grid by its ID
         * @summary Get grid status
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridStatusPvt(gridId: string, options?: any): AxiosPromise<GridStatus> {
            return localVarFp.getGridStatusPvt(gridId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of grids based on provided filters
         * @summary List grids
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [universeId] Universe ID to filter grids
         * @param {boolean} [hasParents] Flag to filter by available parents
         * @param {boolean} [onlyIds] Flag to return only grid IDs
         * @param {boolean} [updatable] Flag to filter grids that can be updated
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGridsPvt(storeId: number, universeId?: number, hasParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options?: any): AxiosPromise<ListGrids200Response> {
            return localVarFp.listGridsPvt(storeId, universeId, hasParents, onlyIds, updatable, version, options).then((request) => request(axios, basePath));
        },
        /**
         * Move a grid position up or down within its parent\'s children list
         * @summary Patch grid for moving position grids
         * @param {number} shopizerGridId Shopizer grid ID to move
         * @param {MoveGrid} moveGrid Grid object to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMoveGridPvt(shopizerGridId: number, moveGrid: MoveGrid, options?: any): AxiosPromise<Grid> {
            return localVarFp.patchMoveGridPvt(shopizerGridId, moveGrid, options).then((request) => request(axios, basePath));
        },
        /**
         * Clones an existing grid, creating a new grid with the same properties
         * @summary Clone grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {GridV2} gridV2 Grid object to update
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCloneGridPvt(gridId: string, gridV2: GridV2, userName?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.postCloneGridPvt(gridId, gridV2, userName, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing grid by its ID
         * @summary Put grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {Grid} grid Grid object to update
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGridPvt(gridId: string, grid: Grid, userName?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.putGridPvt(gridId, grid, userName, options).then((request) => request(axios, basePath));
        },
        /**
         * Request to remove and add product group ids
         * @summary Update product group ids
         * @param {string} gridId Grid ID
         * @param {ProductGroup} productGroup services object
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductGroup(gridId: string, productGroup: ProductGroup, userName?: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateProductGroup(gridId, productGroup, userName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GridEnginePrivateApi - interface
 * @export
 * @interface GridEnginePrivateApi
 */
export interface GridEnginePrivateApiInterface {
    /**
     * Assigns subgrids to a parent grid
     * @summary Assign subgrids to a grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {Array<string>} requestBody Array of grid IDs to assign as children
     * @param {string} [userName] User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApiInterface
     */
    assignSubgridsPvt(gridId: string, requestBody: Array<string>, userName?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * Creates a new grid with the provided details
     * @summary Create a new grid
     * @param {GridV2} gridV2 Grid to create
     * @param {string} [userName] User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApiInterface
     */
    createGridPvt(gridV2: GridV2, userName?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * Deletes a grid by its ID
     * @summary Delete a grid
     * @param {string} gridId ID of the grid to delete
     * @param {string} [userName] User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApiInterface
     */
    deleteGridPvt(gridId: string, userName?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Retrieves a grid by its ID
     * @summary Get grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApiInterface
     */
    getGridPvt(gridId: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * Retrieves the status of a grid by its ID
     * @summary Get grid status
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApiInterface
     */
    getGridStatusPvt(gridId: string, options?: AxiosRequestConfig): AxiosPromise<GridStatus>;

    /**
     * Retrieves a list of grids based on provided filters
     * @summary List grids
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [universeId] Universe ID to filter grids
     * @param {boolean} [hasParents] Flag to filter by available parents
     * @param {boolean} [onlyIds] Flag to return only grid IDs
     * @param {boolean} [updatable] Flag to filter grids that can be updated
     * @param {Array<number>} [version] List of grid versions to filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApiInterface
     */
    listGridsPvt(storeId: number, universeId?: number, hasParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options?: AxiosRequestConfig): AxiosPromise<ListGrids200Response>;

    /**
     * Move a grid position up or down within its parent\'s children list
     * @summary Patch grid for moving position grids
     * @param {number} shopizerGridId Shopizer grid ID to move
     * @param {MoveGrid} moveGrid Grid object to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApiInterface
     */
    patchMoveGridPvt(shopizerGridId: number, moveGrid: MoveGrid, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * Clones an existing grid, creating a new grid with the same properties
     * @summary Clone grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {GridV2} gridV2 Grid object to update
     * @param {string} [userName] User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApiInterface
     */
    postCloneGridPvt(gridId: string, gridV2: GridV2, userName?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * Updates an existing grid by its ID
     * @summary Put grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {Grid} grid Grid object to update
     * @param {string} [userName] User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApiInterface
     */
    putGridPvt(gridId: string, grid: Grid, userName?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * Request to remove and add product group ids
     * @summary Update product group ids
     * @param {string} gridId Grid ID
     * @param {ProductGroup} productGroup services object
     * @param {string} [userName] User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApiInterface
     */
    updateProductGroup(gridId: string, productGroup: ProductGroup, userName?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * GridEnginePrivateApi - object-oriented interface
 * @export
 * @class GridEnginePrivateApi
 * @extends {BaseAPI}
 */
export class GridEnginePrivateApi extends BaseAPI implements GridEnginePrivateApiInterface {
    /**
     * Assigns subgrids to a parent grid
     * @summary Assign subgrids to a grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {Array<string>} requestBody Array of grid IDs to assign as children
     * @param {string} [userName] User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApi
     */
    public assignSubgridsPvt(gridId: string, requestBody: Array<string>, userName?: string, options?: AxiosRequestConfig) {
        return GridEnginePrivateApiFp(this.configuration).assignSubgridsPvt(gridId, requestBody, userName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new grid with the provided details
     * @summary Create a new grid
     * @param {GridV2} gridV2 Grid to create
     * @param {string} [userName] User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApi
     */
    public createGridPvt(gridV2: GridV2, userName?: string, options?: AxiosRequestConfig) {
        return GridEnginePrivateApiFp(this.configuration).createGridPvt(gridV2, userName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a grid by its ID
     * @summary Delete a grid
     * @param {string} gridId ID of the grid to delete
     * @param {string} [userName] User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApi
     */
    public deleteGridPvt(gridId: string, userName?: string, options?: AxiosRequestConfig) {
        return GridEnginePrivateApiFp(this.configuration).deleteGridPvt(gridId, userName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a grid by its ID
     * @summary Get grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApi
     */
    public getGridPvt(gridId: string, options?: AxiosRequestConfig) {
        return GridEnginePrivateApiFp(this.configuration).getGridPvt(gridId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the status of a grid by its ID
     * @summary Get grid status
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApi
     */
    public getGridStatusPvt(gridId: string, options?: AxiosRequestConfig) {
        return GridEnginePrivateApiFp(this.configuration).getGridStatusPvt(gridId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of grids based on provided filters
     * @summary List grids
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [universeId] Universe ID to filter grids
     * @param {boolean} [hasParents] Flag to filter by available parents
     * @param {boolean} [onlyIds] Flag to return only grid IDs
     * @param {boolean} [updatable] Flag to filter grids that can be updated
     * @param {Array<number>} [version] List of grid versions to filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApi
     */
    public listGridsPvt(storeId: number, universeId?: number, hasParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options?: AxiosRequestConfig) {
        return GridEnginePrivateApiFp(this.configuration).listGridsPvt(storeId, universeId, hasParents, onlyIds, updatable, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Move a grid position up or down within its parent\'s children list
     * @summary Patch grid for moving position grids
     * @param {number} shopizerGridId Shopizer grid ID to move
     * @param {MoveGrid} moveGrid Grid object to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApi
     */
    public patchMoveGridPvt(shopizerGridId: number, moveGrid: MoveGrid, options?: AxiosRequestConfig) {
        return GridEnginePrivateApiFp(this.configuration).patchMoveGridPvt(shopizerGridId, moveGrid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clones an existing grid, creating a new grid with the same properties
     * @summary Clone grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {GridV2} gridV2 Grid object to update
     * @param {string} [userName] User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApi
     */
    public postCloneGridPvt(gridId: string, gridV2: GridV2, userName?: string, options?: AxiosRequestConfig) {
        return GridEnginePrivateApiFp(this.configuration).postCloneGridPvt(gridId, gridV2, userName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing grid by its ID
     * @summary Put grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {Grid} grid Grid object to update
     * @param {string} [userName] User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApi
     */
    public putGridPvt(gridId: string, grid: Grid, userName?: string, options?: AxiosRequestConfig) {
        return GridEnginePrivateApiFp(this.configuration).putGridPvt(gridId, grid, userName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request to remove and add product group ids
     * @summary Update product group ids
     * @param {string} gridId Grid ID
     * @param {ProductGroup} productGroup services object
     * @param {string} [userName] User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePrivateApi
     */
    public updateProductGroup(gridId: string, productGroup: ProductGroup, userName?: string, options?: AxiosRequestConfig) {
        return GridEnginePrivateApiFp(this.configuration).updateProductGroup(gridId, productGroup, userName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GridEnginePublicApi - axios parameter creator
 * @export
 */
export const GridEnginePublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a list of grids based on provided filters
         * @summary Get Grids list
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [universeId] Lista de IDs de universo para filtrar
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {boolean} [hasParents] Flag to filter by available parents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGridsPub: async (storeId: number, universeId?: Array<number>, lang?: string, hasParents?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listGridsPub', 'storeId', storeId)
            const localVarPath = `/api/preowned-pub/v3/grids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (universeId) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (hasParents !== undefined) {
                localVarQueryParameter['hasParents'] = hasParents;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GridEnginePublicApi - functional programming interface
 * @export
 */
export const GridEnginePublicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GridEnginePublicApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a list of grids based on provided filters
         * @summary Get Grids list
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [universeId] Lista de IDs de universo para filtrar
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {boolean} [hasParents] Flag to filter by available parents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGridsPub(storeId: number, universeId?: Array<number>, lang?: string, hasParents?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GridPublic>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGridsPub(storeId, universeId, lang, hasParents, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GridEnginePublicApi - factory interface
 * @export
 */
export const GridEnginePublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GridEnginePublicApiFp(configuration)
    return {
        /**
         * Retrieves a list of grids based on provided filters
         * @summary Get Grids list
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [universeId] Lista de IDs de universo para filtrar
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {boolean} [hasParents] Flag to filter by available parents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGridsPub(storeId: number, universeId?: Array<number>, lang?: string, hasParents?: boolean, options?: any): AxiosPromise<Array<GridPublic>> {
            return localVarFp.listGridsPub(storeId, universeId, lang, hasParents, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GridEnginePublicApi - interface
 * @export
 * @interface GridEnginePublicApi
 */
export interface GridEnginePublicApiInterface {
    /**
     * Retrieves a list of grids based on provided filters
     * @summary Get Grids list
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<number>} [universeId] Lista de IDs de universo para filtrar
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {boolean} [hasParents] Flag to filter by available parents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePublicApiInterface
     */
    listGridsPub(storeId: number, universeId?: Array<number>, lang?: string, hasParents?: boolean, options?: AxiosRequestConfig): AxiosPromise<Array<GridPublic>>;

}

/**
 * GridEnginePublicApi - object-oriented interface
 * @export
 * @class GridEnginePublicApi
 * @extends {BaseAPI}
 */
export class GridEnginePublicApi extends BaseAPI implements GridEnginePublicApiInterface {
    /**
     * Retrieves a list of grids based on provided filters
     * @summary Get Grids list
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<number>} [universeId] Lista de IDs de universo para filtrar
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {boolean} [hasParents] Flag to filter by available parents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEnginePublicApi
     */
    public listGridsPub(storeId: number, universeId?: Array<number>, lang?: string, hasParents?: boolean, options?: AxiosRequestConfig) {
        return GridEnginePublicApiFp(this.configuration).listGridsPub(storeId, universeId, lang, hasParents, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GridEngineStepFunctionsApi - axios parameter creator
 * @export
 */
export const GridEngineStepFunctionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets the list of candidate grids for automatic updated, based on their status (visible, published and marked as autoupdatable)
         * @summary Gets the list of candidate grids for automatic update
         * @param {number} storeId Store ID
         * @param {number} [universeId] Universe ID
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUpdatableGridsStp: async (storeId: number, universeId?: number, version?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('findUpdatableGridsStp', 'storeId', storeId)
            const localVarPath = `/api/preowned-stp/v3/grids/find-updatable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (universeId !== undefined) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (version) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if a grid is outdated and requires updating, by evaluating its products
         * @summary Checks if a grid is outdated and requires updating
         * @param {string} gridId Grid ID
         * @param {number} storeId Store ID
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isGridOutdatedStp: async (gridId: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('isGridOutdatedStp', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('isGridOutdatedStp', 'storeId', storeId)
            const localVarPath = `/api/preowned-stp/v3/grids/{gridId}/outdated`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GridEngineStepFunctionsApi - functional programming interface
 * @export
 */
export const GridEngineStepFunctionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GridEngineStepFunctionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets the list of candidate grids for automatic updated, based on their status (visible, published and marked as autoupdatable)
         * @summary Gets the list of candidate grids for automatic update
         * @param {number} storeId Store ID
         * @param {number} [universeId] Universe ID
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUpdatableGridsStp(storeId: number, universeId?: number, version?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridIdData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUpdatableGridsStp(storeId, universeId, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Checks if a grid is outdated and requires updating, by evaluating its products
         * @summary Checks if a grid is outdated and requires updating
         * @param {string} gridId Grid ID
         * @param {number} storeId Store ID
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isGridOutdatedStp(gridId: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridOutdated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isGridOutdatedStp(gridId, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GridEngineStepFunctionsApi - factory interface
 * @export
 */
export const GridEngineStepFunctionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GridEngineStepFunctionsApiFp(configuration)
    return {
        /**
         * Gets the list of candidate grids for automatic updated, based on their status (visible, published and marked as autoupdatable)
         * @summary Gets the list of candidate grids for automatic update
         * @param {number} storeId Store ID
         * @param {number} [universeId] Universe ID
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUpdatableGridsStp(storeId: number, universeId?: number, version?: Array<number>, options?: any): AxiosPromise<GridIdData> {
            return localVarFp.findUpdatableGridsStp(storeId, universeId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if a grid is outdated and requires updating, by evaluating its products
         * @summary Checks if a grid is outdated and requires updating
         * @param {string} gridId Grid ID
         * @param {number} storeId Store ID
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isGridOutdatedStp(gridId: string, storeId: number, lang?: string, options?: any): AxiosPromise<GridOutdated> {
            return localVarFp.isGridOutdatedStp(gridId, storeId, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GridEngineStepFunctionsApi - interface
 * @export
 * @interface GridEngineStepFunctionsApi
 */
export interface GridEngineStepFunctionsApiInterface {
    /**
     * Gets the list of candidate grids for automatic updated, based on their status (visible, published and marked as autoupdatable)
     * @summary Gets the list of candidate grids for automatic update
     * @param {number} storeId Store ID
     * @param {number} [universeId] Universe ID
     * @param {Array<number>} [version] List of grid versions to filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEngineStepFunctionsApiInterface
     */
    findUpdatableGridsStp(storeId: number, universeId?: number, version?: Array<number>, options?: AxiosRequestConfig): AxiosPromise<GridIdData>;

    /**
     * Checks if a grid is outdated and requires updating, by evaluating its products
     * @summary Checks if a grid is outdated and requires updating
     * @param {string} gridId Grid ID
     * @param {number} storeId Store ID
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEngineStepFunctionsApiInterface
     */
    isGridOutdatedStp(gridId: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<GridOutdated>;

}

/**
 * GridEngineStepFunctionsApi - object-oriented interface
 * @export
 * @class GridEngineStepFunctionsApi
 * @extends {BaseAPI}
 */
export class GridEngineStepFunctionsApi extends BaseAPI implements GridEngineStepFunctionsApiInterface {
    /**
     * Gets the list of candidate grids for automatic updated, based on their status (visible, published and marked as autoupdatable)
     * @summary Gets the list of candidate grids for automatic update
     * @param {number} storeId Store ID
     * @param {number} [universeId] Universe ID
     * @param {Array<number>} [version] List of grid versions to filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEngineStepFunctionsApi
     */
    public findUpdatableGridsStp(storeId: number, universeId?: number, version?: Array<number>, options?: AxiosRequestConfig) {
        return GridEngineStepFunctionsApiFp(this.configuration).findUpdatableGridsStp(storeId, universeId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if a grid is outdated and requires updating, by evaluating its products
     * @summary Checks if a grid is outdated and requires updating
     * @param {string} gridId Grid ID
     * @param {number} storeId Store ID
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEngineStepFunctionsApi
     */
    public isGridOutdatedStp(gridId: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return GridEngineStepFunctionsApiFp(this.configuration).isGridOutdatedStp(gridId, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GridEngineUniversePublicApi - axios parameter creator
 * @export
 */
export const GridEngineUniversePublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a paginated list of universes based on provided filters
         * @summary Get universes list. API managed from Shopizer
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUniversesPub: async (storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listUniversesPub', 'storeId', storeId)
            const localVarPath = `/api/preowned-pub/v3/universes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GridEngineUniversePublicApi - functional programming interface
 * @export
 */
export const GridEngineUniversePublicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GridEngineUniversePublicApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a paginated list of universes based on provided filters
         * @summary Get universes list. API managed from Shopizer
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUniversesPub(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageUniverseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUniversesPub(storeId, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GridEngineUniversePublicApi - factory interface
 * @export
 */
export const GridEngineUniversePublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GridEngineUniversePublicApiFp(configuration)
    return {
        /**
         * Retrieves a paginated list of universes based on provided filters
         * @summary Get universes list. API managed from Shopizer
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUniversesPub(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<PageUniverseDto> {
            return localVarFp.listUniversesPub(storeId, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GridEngineUniversePublicApi - interface
 * @export
 * @interface GridEngineUniversePublicApi
 */
export interface GridEngineUniversePublicApiInterface {
    /**
     * Retrieves a paginated list of universes based on provided filters
     * @summary Get universes list. API managed from Shopizer
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEngineUniversePublicApiInterface
     */
    listUniversesPub(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageUniverseDto>;

}

/**
 * GridEngineUniversePublicApi - object-oriented interface
 * @export
 * @class GridEngineUniversePublicApi
 * @extends {BaseAPI}
 */
export class GridEngineUniversePublicApi extends BaseAPI implements GridEngineUniversePublicApiInterface {
    /**
     * Retrieves a paginated list of universes based on provided filters
     * @summary Get universes list. API managed from Shopizer
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridEngineUniversePublicApi
     */
    public listUniversesPub(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return GridEngineUniversePublicApiFp(this.configuration).listUniversesPub(storeId, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GridFilterAPIApi - axios parameter creator
 * @export
 */
export const GridFilterAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/gridfilters/01K6JBNGDRHSPQ8V6GS80QXY49` instead. allows updating a specific filter
         * @summary Request to edit a grid filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {number} storeId ID of the store this query is directed to
         * @param {Gridfilter} gridfilter services object
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        editGridFilter: async (gridFilterId: string, storeId: number, gridfilter: Gridfilter, lang?: string, userId?: string, userToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridFilterId' is not null or undefined
            assertParamExists('editGridFilter', 'gridFilterId', gridFilterId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('editGridFilter', 'storeId', storeId)
            // verify required parameter 'gridfilter' is not null or undefined
            assertParamExists('editGridFilter', 'gridfilter', gridfilter)
            const localVarPath = `/resell-admin/v3/gridfilter/{gridFilterId}`
                .replace(`{${"gridFilterId"}}`, encodeURIComponent(String(gridFilterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (userId != null) {
                localVarHeaderParameter['user-id'] = String(userId);
            }

            if (userToken != null) {
                localVarHeaderParameter['user-token'] = String(userToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gridfilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/gridfilters/01K6J9W1VXC9N5E76W9T72F5VQFilterId}` instead. Allows updating a specific filter
         * @summary Request to update a search Filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {string} gridId The grid identifier
         * @param {number} storeId ID of the store this query is directed to
         * @param {Gridfilters} gridfilters services object
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateCriteriaGrid: async (gridFilterId: string, gridId: string, storeId: number, gridfilters: Gridfilters, lang?: string, userId?: string, userToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridFilterId' is not null or undefined
            assertParamExists('updateCriteriaGrid', 'gridFilterId', gridFilterId)
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('updateCriteriaGrid', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('updateCriteriaGrid', 'storeId', storeId)
            // verify required parameter 'gridfilters' is not null or undefined
            assertParamExists('updateCriteriaGrid', 'gridfilters', gridfilters)
            const localVarPath = `/api/v3/admin/grids/{gridId}/gridfilters/{gridFilterId}`
                .replace(`{${"gridFilterId"}}`, encodeURIComponent(String(gridFilterId)))
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (userId != null) {
                localVarHeaderParameter['user-id'] = String(userId);
            }

            if (userToken != null) {
                localVarHeaderParameter['user-token'] = String(userToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gridfilters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GridFilterAPIApi - functional programming interface
 * @export
 */
export const GridFilterAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GridFilterAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/gridfilters/01K6JBNGDRHSPQ8V6GS80QXY49` instead. allows updating a specific filter
         * @summary Request to edit a grid filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {number} storeId ID of the store this query is directed to
         * @param {Gridfilter} gridfilter services object
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async editGridFilter(gridFilterId: string, storeId: number, gridfilter: Gridfilter, lang?: string, userId?: string, userToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editGridFilter(gridFilterId, storeId, gridfilter, lang, userId, userToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/gridfilters/01K6J9W1VXC9N5E76W9T72F5VQFilterId}` instead. Allows updating a specific filter
         * @summary Request to update a search Filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {string} gridId The grid identifier
         * @param {number} storeId ID of the store this query is directed to
         * @param {Gridfilters} gridfilters services object
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateCriteriaGrid(gridFilterId: string, gridId: string, storeId: number, gridfilters: Gridfilters, lang?: string, userId?: string, userToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCriteriaGrid(gridFilterId, gridId, storeId, gridfilters, lang, userId, userToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GridFilterAPIApi - factory interface
 * @export
 */
export const GridFilterAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GridFilterAPIApiFp(configuration)
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/gridfilters/01K6JBNGDRHSPQ8V6GS80QXY49` instead. allows updating a specific filter
         * @summary Request to edit a grid filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {number} storeId ID of the store this query is directed to
         * @param {Gridfilter} gridfilter services object
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        editGridFilter(gridFilterId: string, storeId: number, gridfilter: Gridfilter, lang?: string, userId?: string, userToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.editGridFilter(gridFilterId, storeId, gridfilter, lang, userId, userToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/gridfilters/01K6J9W1VXC9N5E76W9T72F5VQFilterId}` instead. Allows updating a specific filter
         * @summary Request to update a search Filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {string} gridId The grid identifier
         * @param {number} storeId ID of the store this query is directed to
         * @param {Gridfilters} gridfilters services object
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {string} [userId] User identifier
         * @param {string} [userToken] User token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateCriteriaGrid(gridFilterId: string, gridId: string, storeId: number, gridfilters: Gridfilters, lang?: string, userId?: string, userToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateCriteriaGrid(gridFilterId, gridId, storeId, gridfilters, lang, userId, userToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GridFilterAPIApi - interface
 * @export
 * @interface GridFilterAPIApi
 */
export interface GridFilterAPIApiInterface {
    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/gridfilters/01K6JBNGDRHSPQ8V6GS80QXY49` instead. allows updating a specific filter
     * @summary Request to edit a grid filter
     * @param {string} gridFilterId The grid filter identifier
     * @param {number} storeId ID of the store this query is directed to
     * @param {Gridfilter} gridfilter services object
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridFilterAPIApiInterface
     */
    editGridFilter(gridFilterId: string, storeId: number, gridfilter: Gridfilter, lang?: string, userId?: string, userToken?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/gridfilters/01K6J9W1VXC9N5E76W9T72F5VQFilterId}` instead. Allows updating a specific filter
     * @summary Request to update a search Filter
     * @param {string} gridFilterId The grid filter identifier
     * @param {string} gridId The grid identifier
     * @param {number} storeId ID of the store this query is directed to
     * @param {Gridfilters} gridfilters services object
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridFilterAPIApiInterface
     */
    updateCriteriaGrid(gridFilterId: string, gridId: string, storeId: number, gridfilters: Gridfilters, lang?: string, userId?: string, userToken?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * GridFilterAPIApi - object-oriented interface
 * @export
 * @class GridFilterAPIApi
 * @extends {BaseAPI}
 */
export class GridFilterAPIApi extends BaseAPI implements GridFilterAPIApiInterface {
    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/gridfilters/01K6JBNGDRHSPQ8V6GS80QXY49` instead. allows updating a specific filter
     * @summary Request to edit a grid filter
     * @param {string} gridFilterId The grid filter identifier
     * @param {number} storeId ID of the store this query is directed to
     * @param {Gridfilter} gridfilter services object
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridFilterAPIApi
     */
    public editGridFilter(gridFilterId: string, storeId: number, gridfilter: Gridfilter, lang?: string, userId?: string, userToken?: string, options?: AxiosRequestConfig) {
        return GridFilterAPIApiFp(this.configuration).editGridFilter(gridFilterId, storeId, gridfilter, lang, userId, userToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pvt/v3/grids/01K6J9W1VXC9N5E76W9T72F5VQ/gridfilters/01K6J9W1VXC9N5E76W9T72F5VQFilterId}` instead. Allows updating a specific filter
     * @summary Request to update a search Filter
     * @param {string} gridFilterId The grid filter identifier
     * @param {string} gridId The grid identifier
     * @param {number} storeId ID of the store this query is directed to
     * @param {Gridfilters} gridfilters services object
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {string} [userId] User identifier
     * @param {string} [userToken] User token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof GridFilterAPIApi
     */
    public updateCriteriaGrid(gridFilterId: string, gridId: string, storeId: number, gridfilters: Gridfilters, lang?: string, userId?: string, userToken?: string, options?: AxiosRequestConfig) {
        return GridFilterAPIApiFp(this.configuration).updateCriteriaGrid(gridFilterId, gridId, storeId, gridfilters, lang, userId, userToken, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GridFilterPrivateApi - axios parameter creator
 * @export
 */
export const GridFilterPrivateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * allows updating a specific filter
         * @summary Request to update a search Filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {string} gridId The grid identifier
         * @param {GridfiltersV2} gridfiltersV2 services object
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCriteriaGridPvt: async (gridFilterId: string, gridId: string, gridfiltersV2: GridfiltersV2, userName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridFilterId' is not null or undefined
            assertParamExists('updateCriteriaGridPvt', 'gridFilterId', gridFilterId)
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('updateCriteriaGridPvt', 'gridId', gridId)
            // verify required parameter 'gridfiltersV2' is not null or undefined
            assertParamExists('updateCriteriaGridPvt', 'gridfiltersV2', gridfiltersV2)
            const localVarPath = `/api/preowned-pvt/v3/grids/{gridId}/gridfilters/{gridFilterId}`
                .replace(`{${"gridFilterId"}}`, encodeURIComponent(String(gridFilterId)))
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userName != null) {
                localVarHeaderParameter['user-name'] = String(userName);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gridfiltersV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GridFilterPrivateApi - functional programming interface
 * @export
 */
export const GridFilterPrivateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GridFilterPrivateApiAxiosParamCreator(configuration)
    return {
        /**
         * allows updating a specific filter
         * @summary Request to update a search Filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {string} gridId The grid identifier
         * @param {GridfiltersV2} gridfiltersV2 services object
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCriteriaGridPvt(gridFilterId: string, gridId: string, gridfiltersV2: GridfiltersV2, userName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCriteriaGridPvt(gridFilterId, gridId, gridfiltersV2, userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GridFilterPrivateApi - factory interface
 * @export
 */
export const GridFilterPrivateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GridFilterPrivateApiFp(configuration)
    return {
        /**
         * allows updating a specific filter
         * @summary Request to update a search Filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {string} gridId The grid identifier
         * @param {GridfiltersV2} gridfiltersV2 services object
         * @param {string} [userName] User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCriteriaGridPvt(gridFilterId: string, gridId: string, gridfiltersV2: GridfiltersV2, userName?: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateCriteriaGridPvt(gridFilterId, gridId, gridfiltersV2, userName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GridFilterPrivateApi - interface
 * @export
 * @interface GridFilterPrivateApi
 */
export interface GridFilterPrivateApiInterface {
    /**
     * allows updating a specific filter
     * @summary Request to update a search Filter
     * @param {string} gridFilterId The grid filter identifier
     * @param {string} gridId The grid identifier
     * @param {GridfiltersV2} gridfiltersV2 services object
     * @param {string} [userName] User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridFilterPrivateApiInterface
     */
    updateCriteriaGridPvt(gridFilterId: string, gridId: string, gridfiltersV2: GridfiltersV2, userName?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * GridFilterPrivateApi - object-oriented interface
 * @export
 * @class GridFilterPrivateApi
 * @extends {BaseAPI}
 */
export class GridFilterPrivateApi extends BaseAPI implements GridFilterPrivateApiInterface {
    /**
     * allows updating a specific filter
     * @summary Request to update a search Filter
     * @param {string} gridFilterId The grid filter identifier
     * @param {string} gridId The grid identifier
     * @param {GridfiltersV2} gridfiltersV2 services object
     * @param {string} [userName] User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridFilterPrivateApi
     */
    public updateCriteriaGridPvt(gridFilterId: string, gridId: string, gridfiltersV2: GridfiltersV2, userName?: string, options?: AxiosRequestConfig) {
        return GridFilterPrivateApiFp(this.configuration).updateCriteriaGridPvt(gridFilterId, gridId, gridfiltersV2, userName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SearchGridsApi - axios parameter creator
 * @export
 */
export const SearchGridsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pub/v3/grids` instead.
         * @summary Get Grids list
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [universeId] Lista de IDs de universo para filtrar
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {boolean} [showOnlyParents] Flag to filter by available parents
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listGridsPublic: async (storeId: number, universeId?: Array<number>, lang?: string, showOnlyParents?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listGridsPublic', 'storeId', storeId)
            const localVarPath = `/api/v3/search/grids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (universeId) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (showOnlyParents !== undefined) {
                localVarQueryParameter['showOnlyParents'] = showOnlyParents;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchGridsApi - functional programming interface
 * @export
 */
export const SearchGridsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchGridsApiAxiosParamCreator(configuration)
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pub/v3/grids` instead.
         * @summary Get Grids list
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [universeId] Lista de IDs de universo para filtrar
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {boolean} [showOnlyParents] Flag to filter by available parents
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async listGridsPublic(storeId: number, universeId?: Array<number>, lang?: string, showOnlyParents?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GridPublic>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGridsPublic(storeId, universeId, lang, showOnlyParents, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SearchGridsApi - factory interface
 * @export
 */
export const SearchGridsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchGridsApiFp(configuration)
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pub/v3/grids` instead.
         * @summary Get Grids list
         * @param {number} storeId ID of the store this query is directed to
         * @param {Array<number>} [universeId] Lista de IDs de universo para filtrar
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {boolean} [showOnlyParents] Flag to filter by available parents
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listGridsPublic(storeId: number, universeId?: Array<number>, lang?: string, showOnlyParents?: boolean, options?: any): AxiosPromise<Array<GridPublic>> {
            return localVarFp.listGridsPublic(storeId, universeId, lang, showOnlyParents, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchGridsApi - interface
 * @export
 * @interface SearchGridsApi
 */
export interface SearchGridsApiInterface {
    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pub/v3/grids` instead.
     * @summary Get Grids list
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<number>} [universeId] Lista de IDs de universo para filtrar
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {boolean} [showOnlyParents] Flag to filter by available parents
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SearchGridsApiInterface
     */
    listGridsPublic(storeId: number, universeId?: Array<number>, lang?: string, showOnlyParents?: boolean, options?: AxiosRequestConfig): AxiosPromise<Array<GridPublic>>;

}

/**
 * SearchGridsApi - object-oriented interface
 * @export
 * @class SearchGridsApi
 * @extends {BaseAPI}
 */
export class SearchGridsApi extends BaseAPI implements SearchGridsApiInterface {
    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pub/v3/grids` instead.
     * @summary Get Grids list
     * @param {number} storeId ID of the store this query is directed to
     * @param {Array<number>} [universeId] Lista de IDs de universo para filtrar
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {boolean} [showOnlyParents] Flag to filter by available parents
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SearchGridsApi
     */
    public listGridsPublic(storeId: number, universeId?: Array<number>, lang?: string, showOnlyParents?: boolean, options?: AxiosRequestConfig) {
        return SearchGridsApiFp(this.configuration).listGridsPublic(storeId, universeId, lang, showOnlyParents, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SearchUniverseApi - axios parameter creator
 * @export
 */
export const SearchUniverseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pub/v3/universes` instead.
         * @summary Get universes list
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listUniverses: async (storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listUniverses', 'storeId', storeId)
            const localVarPath = `/api/v3/search/universes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchUniverseApi - functional programming interface
 * @export
 */
export const SearchUniverseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchUniverseApiAxiosParamCreator(configuration)
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pub/v3/universes` instead.
         * @summary Get universes list
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async listUniverses(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageUniverseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUniverses(storeId, page, size, sort, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SearchUniverseApi - factory interface
 * @export
 */
export const SearchUniverseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchUniverseApiFp(configuration)
    return {
        /**
         * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pub/v3/universes` instead.
         * @summary Get universes list
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listUniverses(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: any): AxiosPromise<PageUniverseDto> {
            return localVarFp.listUniverses(storeId, page, size, sort, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchUniverseApi - interface
 * @export
 * @interface SearchUniverseApi
 */
export interface SearchUniverseApiInterface {
    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pub/v3/universes` instead.
     * @summary Get universes list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SearchUniverseApiInterface
     */
    listUniverses(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<PageUniverseDto>;

}

/**
 * SearchUniverseApi - object-oriented interface
 * @export
 * @class SearchUniverseApi
 * @extends {BaseAPI}
 */
export class SearchUniverseApi extends BaseAPI implements SearchUniverseApiInterface {
    /**
     * Deprecated - this endpoint will be removed in a few weeks. Use `/api/preowned-pub/v3/universes` instead.
     * @summary Get universes list
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SearchUniverseApi
     */
    public listUniverses(storeId: number, page?: number, size?: number, sort?: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return SearchUniverseApiFp(this.configuration).listUniverses(storeId, page, size, sort, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


